import React from "react";
import { Link } from "react-router-dom";
import Nav from "./landing/Nav";
import Footer from "./landing/Footer";
import Seo, { breadcrumbLd } from "./Seo";
import { META } from "../lib/seo-meta";
import { routePath } from "../lib/routes";
import { SITE } from "../content/site";

// Shared shell for public content pages: SEO + header + breadcrumbs + main + footer.
export default function PublicLayout({ pageKey, lang, crumbs = [], jsonLd = [], overlayNav = false, children }) {
  const m = META[pageKey]?.[lang] || {};
  const c = SITE[lang];
  const trail = [{ name: c.nav.home, path: routePath("home", lang) }, ...crumbs];
  const ld = crumbs.length ? [breadcrumbLd(trail), ...jsonLd] : jsonLd;
  return (
    <div className="min-h-screen bg-white">
      <Seo pageKey={pageKey} lang={lang} title={m.title} description={m.description} image={m.image} jsonLd={ld} />
      {overlayNav ? <Nav /> : <><Nav solid /><div className="h-[60px] md:h-[68px]" /></>}
      {crumbs.length > 0 && !overlayNav && (
        <nav aria-label="Breadcrumb" className="mx-auto max-w-[1100px] px-6 pt-8 md:px-8" data-testid="breadcrumbs">
          <ol className="flex flex-wrap items-center gap-1.5 text-xs font-light text-[#9a9d98]">
            {trail.map((t, i) => (
              <li key={t.path} className="flex items-center gap-1.5">
                {i > 0 && <span aria-hidden="true">/</span>}
                {i < trail.length - 1
                  ? <Link to={t.path} className="transition-colors hover:text-[#0e7c6b]">{t.name}</Link>
                  : <span aria-current="page" className="text-[#4a4a4a]">{t.name}</span>}
              </li>
            ))}
          </ol>
        </nav>
      )}
      <main id="main">{children}</main>
      <Footer />
    </div>
  );
}

export const H1 = ({ children }) => (
  <h1 className="font-display text-4xl font-light leading-tight tracking-tight text-[#050505] sm:text-5xl lg:text-6xl">{children}</h1>
);

export const Lead = ({ children }) => (
  <p className="mt-6 max-w-2xl text-base font-light leading-relaxed text-[#4a4a4a] md:text-lg">{children}</p>
);

export const SectionCta = ({ title, text, lang, onClick }) => (
  <section className="mt-24 rounded-3xl bg-[#141514] p-10 text-white md:p-16">
    <h2 className="font-display text-2xl font-light md:text-3xl">{title}</h2>
    <p className="mt-3 max-w-xl text-base font-light leading-relaxed text-white/70">{text}</p>
    <Link to={routePath("contact", lang)} onClick={onClick} data-testid="page-cta-contact"
      className="mt-8 inline-block rounded-full bg-[#0e7c6b] px-7 py-3 text-sm font-medium text-white transition-opacity hover:opacity-90">
      {SITE[lang].common.discussProject}
    </Link>
  </section>
);
